var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5205_5177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0657 20.3746C39.0657 18.7358 38.9327 17.54 38.6449 16.2998H19.9316V23.6964H30.9159C30.6945 25.5346 29.4987 28.3029 26.8411 30.163L26.8039 30.4106L32.7206 34.9943L33.1306 35.0352C36.8953 31.5583 39.0657 26.4426 39.0657 20.3746Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9303 39.8624C25.3117 39.8624 29.8294 38.0906 33.1293 35.0346L26.8398 30.1624C25.1568 31.3361 22.8978 32.1555 19.9303 32.1555C14.6597 32.1555 10.1862 28.6787 8.59156 23.873L8.35782 23.8929L2.20546 28.6543L2.125 28.8779C5.40256 35.3888 12.1349 39.8624 19.9303 39.8624Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59252 23.8736C8.17176 22.6335 7.92824 21.3046 7.92824 19.9317C7.92824 18.5585 8.17176 17.2298 8.57038 15.9897L8.55924 15.7256L2.32977 10.8877L2.12595 10.9846C0.775115 13.6865 0 16.7205 0 19.9317C0 23.1428 0.775115 26.1767 2.12595 28.8785L8.59252 23.8736Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9303 7.70672C23.6729 7.70672 26.1975 9.32336 27.6371 10.6744L33.2621 5.18214C29.8074 1.97099 25.3117 0 19.9303 0C12.1349 0 5.40256 4.47343 2.125 10.9843L8.56943 15.9893C10.1862 11.1837 14.6597 7.70672 19.9303 7.70672Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5205_5177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.084,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.aa9e44ed0020a50ab3d0a6d58cd5c767.svg";
export { ForwardRef as ReactComponent };